import getHelper from '../../../services/getHelper';

const EmployerHelper = getHelper('/employers/:id', {
  matchDeclaration: getHelper('/match-declarations'),
});

export default EmployerHelper;
